(function (w, d) {
	function createScript(src, id) {
		const element = d.createElement('script');
		element.async = true;
		if (id) {
			element.id = id;
		}
		element.src = src;
		element.crossorigin = 'anonymous';
		const script = d.getElementsByTagName('script')[0];
		script.parentNode.insertBefore(element, script);
	}

	const recaptchaKey = '?onload=onloadCallback&render=explicit';
	const recaptchaArg = ['https://www.google.com/recaptcha/api.js' + recaptchaKey];

	setTimeout(() => {
		createScript.apply(null, recaptchaArg);
	}, 5000);
})(window, document);
